module.exports = __webpack_public_path__ + "img/afternoon_study1.138cbb6c.png";